<div class="card card-widget campanha-roi-widget-roi {{KPI.cssClass}}">
    <div class="card-body">
        <div class="card-icon">
            <i [class]="KPI.icon"></i>
        </div>
        <h5 class="card-title">
            <span *ngIf="!isLoading">{{roi | decimalFormat: 1:2:2}}x</span>
            <span *ngIf="isLoading"><i class='fas fa-spinner fa-pulse' aria-hidden='true'></i></span>
        </h5>
        <h6 class="card-subtitle">
            {{KPI.name}}
        </h6>
    </div>
</div>